/**
 * LTI Enroll Exam
 * LTI Enroll Exam for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ArrayOfGraceDocumentsStatus from './ArrayOfGraceDocumentsStatus';
import EvauFileUploadDates from './EvauFileUploadDates';
import FormativeActions from './FormativeActions';

/**
 * The FormativeActionsPerPeriod model module.
 * @module model/FormativeActionsPerPeriod
 * @version 2.0.0
 */
class FormativeActionsPerPeriod {
    /**
     * Constructs a new <code>FormativeActionsPerPeriod</code>.
     * @alias module:model/FormativeActionsPerPeriod
     */
    constructor() { 
        
        FormativeActionsPerPeriod.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FormativeActionsPerPeriod</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FormativeActionsPerPeriod} obj Optional instance to populate.
     * @return {module:model/FormativeActionsPerPeriod} The populated <code>FormativeActionsPerPeriod</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FormativeActionsPerPeriod();

            if (data.hasOwnProperty('current')) {
                obj['current'] = FormativeActions.constructFromObject(data['current']);
            }
            if (data.hasOwnProperty('next')) {
                obj['next'] = FormativeActions.constructFromObject(data['next']);
            }
            if (data.hasOwnProperty('certificates_academic_agreements')) {
                obj['certificates_academic_agreements'] = ApiClient.convertToType(data['certificates_academic_agreements'], [Object]);
            }
            if (data.hasOwnProperty('available_evau_file_upload')) {
                obj['available_evau_file_upload'] = EvauFileUploadDates.constructFromObject(data['available_evau_file_upload']);
            }
            if (data.hasOwnProperty('grace_document_status')) {
                obj['grace_document_status'] = ArrayOfGraceDocumentsStatus.constructFromObject(data['grace_document_status']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/FormativeActions} current
 */
FormativeActionsPerPeriod.prototype['current'] = undefined;

/**
 * @member {module:model/FormativeActions} next
 */
FormativeActionsPerPeriod.prototype['next'] = undefined;

/**
 * @member {Array.<Object>} certificates_academic_agreements
 */
FormativeActionsPerPeriod.prototype['certificates_academic_agreements'] = undefined;

/**
 * @member {module:model/EvauFileUploadDates} available_evau_file_upload
 */
FormativeActionsPerPeriod.prototype['available_evau_file_upload'] = undefined;

/**
 * @member {module:model/ArrayOfGraceDocumentsStatus} grace_document_status
 */
FormativeActionsPerPeriod.prototype['grace_document_status'] = undefined;






export default FormativeActionsPerPeriod;

